import { render, staticRenderFns } from "./CorporateAnnouncementStocks.vue?vue&type=template&id=715bb682&scoped=true"
import script from "./CorporateAnnouncementStocks.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementStocks.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementStocks.vue?vue&type=style&index=0&id=715bb682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715bb682",
  null
  
)

export default component.exports